import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useBoolean } from "@/hooks/use-boolean";
import { PropsWithChildren, useCallback } from "react";
import useTranslation from "@babackapp/translations/use-translation";
import { CreateOneWorkflowDto } from "@babackapp/private-api-client/types";
import { useWorkflowsContext } from "../use-workflows-context";
import AddWebflowForm from "./add-workflow-form";
import useShop from "@babackapp/private-api-client/client/use-shop";

export const AddWorkFlowDialog = ({ children }: PropsWithChildren) => {
  const open = useBoolean(false);
  const t = useTranslation();
  const { data: shop } = useShop();
  const { onAddWorkflow } = useWorkflowsContext();

  const onSubmit = useCallback(
    (data: CreateOneWorkflowDto) => {
      onCloseForm();
      return onAddWorkflow(data);
    },
    [onAddWorkflow, shop],
  );

  const onCloseForm = useCallback(() => {
    open.setValue(false);
  }, [open]);

  return (
    <Dialog open={open.value} onOpenChange={open.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>{t("workflow.create.create")}</DialogTitle>
          <DialogDescription>{t("workflow.create.subtitle")}</DialogDescription>
        </DialogHeader>
        <AddWebflowForm onSubmit={onSubmit} onCloseForm={onCloseForm} />
      </DialogContent>
    </Dialog>
  );
};
